export default {
    path: 'cancel-reason',
    component: () => import('../CancelReason.vue'),
    children: [
        {
            path: '',
            name: 'Lý do hủy đơn',
            component: () => import('../table/Table.vue')
        },
    ],
};
